import { createEvent } from "@cobuildlab/react-simple-state";
import { Message } from "@devsplan/wealthclub-shared";

export const OnCreateMessage = createEvent<Message>();
export const OnCreateMessageError = createEvent();
export const OnUpdateMessage = createEvent<Message>();
export const OnUpdateMessageError = createEvent();
